// components/TextEditorQuill.jsx
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function TextEditorQuill({
  value,
  onChange,
  modules = {
    toolbar: [
      [
        { font: [] },
        { header: [1, 2, 3, 4, 5, 6, false] },
        { size: ['small', false, 'large', 'huge'] },
      ],
      // 텍스트 스타일링
      ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
      // 블록 및 리스트
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ color: [] }, { background: [] }],

      // 포맷 초기화
      ['clean'],

      // 첨부
      ['link'],
    ],
  },
}) {
  return <ReactQuill theme="snow" value={value} onChange={onChange} modules={modules} />;
}
